export default "__VITE_ASSET__pcpr7jKp__"